<template>
  <div class="proposal__wrap">
    <div class="section shadow dsc">
      <div style="margin-bottom: 10px">
        <el-button style="margin-right:10px" type="text" @click="$router.push('/finance')"
          ><el-badge class="item" :value="isb" :hidden="!isb"
            >代理提现</el-badge
          ></el-button
        >
        <el-button style="margin-right:10px" type="primary"
          ><el-badge  class="item" :value="isb1" :hidden="!isb1"
            >用户提现</el-badge
          ></el-button
        >
        <el-button style="margin-right:10px" type="text" @click="$router.push('/companyList')"
          ><el-badge  class="item" :value="isb2" :hidden="!isb2"
            >企业用户提现</el-badge
          ></el-button
        >
        <el-button type="text" @click="$router.push('/studentsWithdraw')"
          >
          <el-badge class="item" :value="isb3" :hidden="!isb3">学生提现</el-badge>
          </el-button>
      </div>
      <div class="filter__wrap">
        <div>
          <el-radio-group v-model="table.params.status" @change="handleTabs">
            <!-- <el-radio-button :label="4">入账明细</el-radio-button> -->
            <el-radio-button :label="1">审核中</el-radio-button>
            <el-radio-button :label="2">提现成功</el-radio-button>
            <el-radio-button :label="3">提现未通过</el-radio-button>
          </el-radio-group>
        </div>
        <div class="flex">
          <el-form ref="elFormDom" inline :model="table.params">
            <el-form-item label="" prop="keyword">
              <el-input
                clearable
                v-model="table.params.keyword"
                placeholder="请输入关键字"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleSearch"
                >查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        v-if="this.table.params.status == 1"
        has-pagionation
        title=""
        addText="添加"
        :field="field1"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:company_name="{ row }">
          <div>{{ row.entry_at }}入职</div>
          <div>{{ row.company_name }}</div>
        </template>
        <template v-slot:proof_images="{ row }">
          <el-image
            v-for="(item, index) in row.proof_image_arr"
            :key="index"
            style="width: 50px; height: 50px; margin: 0 10px 0 0"
            :src="item"
            :preview-src-list="row.proof_image_arr"
          >
          </el-image>
        </template>
        <template v-slot:action="{ row }">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-circle-check"
            @click="showAccept(row)"
            >确认通过</el-button
          >
          <el-button
            type="text"
            size="mini"
            icon="el-icon-circle-close"
            class="delBtn"
            @click="showRefuse(row)"
            >拒绝</el-button
          >
        </template>
      </VTable>
      <!-- 提现成功 -->
      <VTable
        v-if="this.table.params.status !== 1"
        has-pagionation
        title=""
        addText="添加"
        :field="this.table.params.status == 2 ? field2 : field3"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        ><template v-slot:company_name="{ row }">
          <div>{{ row.entry_at }}入职</div>
          <div>{{ row.company_name }}</div> </template
        ><template v-slot:proof_images="{ row }">
          <el-image
            v-for="(item, index) in row.proof_image_arr"
            :key="index"
            style="width: 50px; height: 50px; margin: 0 10px 0 0"
            :src="item"
            :preview-src-list="row.proof_image_arr"
          >
          </el-image>
        </template>
      </VTable>
    </div>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Detail from "./components/Detail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportList",
  mixins: [mixinTable],
  components: {
    VTable,
    Detail,
  },
  data() {
    return {
      field1: [
        { name: "name", label: "用户名称", hidden: false, width: 100 },
        { name: "phone", label: "手机号", hidden: false, width: 120 },
        {
          name: "free_vip_start",
          label: "入会日期",
          hidden: false,
          width: 120,
        },
        { name: "company_name", label: "入职企业", hidden: false },
        { name: "proof_images", label: "入职凭证", hidden: false, width: 200 },
        { name: "amount", label: "提现金额", hidden: false, width: 100 },
        {
          name: "alipay_real_name",
          label: "支付宝姓名",
          hidden: false,
          width: 100,
        },
        {
          name: "alipay_account",
          label: "支付宝账号",
          hidden: false,
        },
        { name: "create_time", label: "申请时间", hidden: false, width: 150 },
        { name: "action", label: "操作", width: "160", hidden: false },
      ],
      field2: [
        { name: "name", label: "用户名称", hidden: false, width: 100 },
        { name: "phone", label: "手机号", hidden: false, width: 120 },
        {
          name: "free_vip_start",
          label: "入会日期",
          hidden: false,
          width: 120,
        },
        { name: "company_name", label: "入职企业", hidden: false },
        { name: "proof_images", label: "入职凭证", hidden: false, width: 200 },
        { name: "amount", label: "提现金额", hidden: false, width: 100 },
        {
          name: "alipay_real_name",
          label: "支付宝姓名",
          hidden: false,
          width: 100,
        },
        {
          name: "alipay_account",
          label: "支付宝账号",
          hidden: false,
        },
        { name: "create_time", label: "申请时间", hidden: false, width: 150 },
      ],
      field3: [
        { name: "name", label: "用户名称", hidden: false, width: 100 },
        { name: "phone", label: "手机号", hidden: false, width: 120 },
        {
          name: "free_vip_start",
          label: "入会日期",
          hidden: false,
          width: 120,
        },
        { name: "company_name", label: "入职企业", hidden: false },
        { name: "proof_images", label: "入职凭证", hidden: false, width: 200 },
        { name: "amount", label: "提现金额", hidden: false, width: 100 },
        {
          name: "alipay_real_name",
          label: "支付宝姓名",
          hidden: false,
          width: 100,
        },
        {
          name: "alipay_account",
          label: "支付宝账号",
          hidden: false,
        },
        { name: "create_time", label: "申请时间", hidden: false, width: 150 },
        { name: "check_time", label: "处理时间", hidden: false, width: 150 },
        { name: "refuse_reason", label: "原因", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          keyword: "",
          status: 1, // 状态 4:入账明细 1:审核中 2:已通过 3:已拒绝
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      type: 1,
      isb: '',
      isb1: '',
      isb2: '',
      isb3: ''
    };
  },
  created() {
    this.$http
      .post("/admin/notice/new", {})
      .then((res) => {
        if (res.code === 1) {
          this.isb = res.data.withdraw_unread;
          this.isb1 = res.data.allowance_unread;
          this.isb2 = res.data.company_withdraw_unread;
          this.isb3 = res.data.auth_withdraw_unread;
        }
      })
      .then(() => {
        this.getTable();
      });
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/userAllowance/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    //通过 状态 2:通过
    showAccept(row) {
      this.$confirm(`确认同意 ${row.name}的提现吗？`, "审核同意", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          let _params = {
            id: row.id,
            status: 2,
          };
          this.$http
            .post("/admin/userAllowance/operation", _params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.getTable();
              } else {
                this.$message.success(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    // 拒绝 状态  3:拒绝
    showRefuse(row) {
      this.$prompt(`拒绝 ${row.name}的提现`, "审核拒绝", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入原因",
      })
        .then(({ value }) => {
          let _params = {
            id: row.id,
            status: 3,
            refuse_reason: value,
          };
          this.$http
            .post("/admin/userAllowance/operation", _params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.getTable();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.dsc {
  padding: 10px 20px;
  margin: 0 0 10px;
}
::v-deep .el-badge__content.is-fixed { 
  right: 1px;
}
</style>